import { render } from "./declare-page.vue?vue&type=template&id=2f1aad0c&scoped=true"
import script from "./declare-page.vue?vue&type=script&lang=js"
export * from "./declare-page.vue?vue&type=script&lang=js"

import "./declare-page.vue?vue&type=style&index=0&id=2f1aad0c&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1aad0c"]])

export default __exports__